require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-australian-design-review-conrad-architects-studio.json") })
        }
      }, "path---journal-australian-design-review-conrad-architects-studio");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-australian-design-review-conrad-architects-studio!./.cache/json/journal-australian-design-review-conrad-architects-studio.json
// module id = 457
// module chunks = 231608221292675